import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AnalyticsDashboard from './pages/analytics-dashboard';
import ParticipantRegistration from './pages/participant-registration';
import RouletteGameScreen from './pages/roulette-game-screen';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<RouletteGameScreen />} />
        <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
        <Route path="/participant-registration" element={<ParticipantRegistration />} />
        <Route path="/roulette-game-screen" element={<RouletteGameScreen />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
